import api from "services/api";

export interface IUploadDocumentResponse {
  url: string;
  fileName: string;
  fileSize: number;
  documentId: string;
}

/**
 * Faz upload de um documento PDF para políticas de benefício personalizadas.
 * @param file - Arquivo PDF a ser enviado
 * @param workspaceId - ID do workspace (opcional, para criação)
 * @returns Informações do documento salvo
 */
export async function uploadBenefitsPolicyDocument(
  file: File,
  workspaceId?: string
): Promise<IUploadDocumentResponse> {
  const formData = new FormData();
  formData.append("file", file);

  if (workspaceId) {
    formData.append("workspaceId", workspaceId);
  }

  const response = await api.post<IUploadDocumentResponse>(
    "/v2/workspaces/benefits-policy/document",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  const raw = response.data as any;
  return (raw?.data && typeof raw.data === "object") ? raw.data : raw;
}

/**
 * Remove um documento de política de benefício.
 * @param documentId - ID do documento a ser removido
 * @param workspaceId - ID do workspace (opcional)
 */
export async function deleteBenefitsPolicyDocument(
  documentId: string,
  workspaceId?: string
): Promise<void> {
  const params = workspaceId ? { workspaceId } : {};

  await api.delete(`/v2/workspaces/benefits-policy/document/${documentId}`, {
    params,
  });
}

/**
 * Obtém informações do documento de política de benefício.
 * @param workspaceId - ID do workspace
 * @returns Informações do documento ou null se não existir
 */
export async function getBenefitsPolicyDocument(
  workspaceId: string
): Promise<IUploadDocumentResponse | null> {
  try {
    const response = await api.get<IUploadDocumentResponse>(
      `/v2/workspaces/${workspaceId}/benefits-policy/document`
    );

    const raw = response.data as any;
    return (raw?.data && typeof raw.data === "object") ? raw.data : raw;
  } catch (error: any) {
    // Se não encontrou documento, retorna null
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
}
